import { useOneTimeMessagesDismissed } from '@trello/business-logic-react/member';
import { useFeatureGate } from '@trello/feature-gate-client';

export const useIsEligibleForPersonalProductivitySurveyBanner = () => {
  const { value: isEligible } = useFeatureGate(
    'ghost_personal_productivity_survey',
  );
  const { isOneTimeMessageDismissed } = useOneTimeMessagesDismissed();

  return {
    wouldRender:
      isEligible &&
      !isOneTimeMessageDismissed('personal-productivity-survey-banner'),
  };
};
